import { render, staticRenderFns } from "./FspAcknowledgeFormLongevity.vue?vue&type=template&id=49149c90&"
import script from "./FspAcknowledgeFormLongevity.vue?vue&type=script&lang=js&"
export * from "./FspAcknowledgeFormLongevity.vue?vue&type=script&lang=js&"
import style0 from "./FspAcknowledgeFormLongevity.vue?vue&type=style&index=0&id=49149c90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports